import { createSelector } from 'reselect';
import { ICrmDomain } from './model';
import { EBookingActivityStatus, ITypeCode, IFilter } from 'services/CrmApi/types/DirectoryEntry';


export const crmDomain = (state: any): ICrmDomain => state.crm;

export const typesFilterSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): ITypeCode[] => domain.filters.typeCodes
);

export const countriesFilterSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): string[] => domain.filters.countryCodes
);

export const stagesFilterSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): string | null => domain.filters.leadStageCode
);

export const scoresFilterSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): number | null => domain.filters.leadScoreGte
);

export const managerFilterSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): string | null => domain.filters.managerId
);

export const managerTextFilterSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): string => domain.data.managerText
);

export const wholeFilterSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): IFilter => domain.filters
);

export const confirmedFiltersSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): IFilter => domain.confirmedFilters
);

export const termFilterSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): string => domain.filters.term
);

export const bookingActivityFilterSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): EBookingActivityStatus | null => domain.filters.bookingActivityStatus
);

export const isDirtyEditCompanyProfileSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): boolean => domain.data.isDirtyEditCompanyProfile
);

export const isDirtyEditContactProfileSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): boolean => domain.data.isDirtyEditContactProfile
);

export const isSubscribeModalOpenSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): boolean => domain.subscription.subscribeModalOpen
);

export const isUnsubscribeModalOpenSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): boolean => domain.subscription.unsubscribeModalOpen
);

export const isNotificationsSubscriptionPendingSelector = createSelector(
  crmDomain,
  (domain: ICrmDomain): boolean => domain.subscription.isPending
);
